




































































import Vue from 'vue';
import Component from 'vue-class-component';
import CompanySelectInput from '@/components/input/CompanySelectInput.vue';
import LanguageSelectInput from '@/components/input/LanguageSelectInput.vue';
import AppendixSelectInput from '@/components/input/AppendixSelectInput.vue';
import SessionTimer from '@/components/common/SessionTimer.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import ApiUtils from '@/utils/ApiUtils';
import IconButton from '@/components/button/IconButton.vue';
import UserApi from '@/api/UserApi';
import {HelpdeskTokenRetrieveResponse, SendPasswordResetEmailResponse} from '@/model/CommonModel';
import MessageUtils from '@/utils/MessageUtils';
import SessionSelector from '@/components/common/SessionSelector.vue';
import AppSession from '@/store/AppSession';
import ChatBotButton from '@/components/common/ChatBotButton.vue';

declare const appProp: any;

@Component({
             components: {
               ChatBotButton,
               IconButton,
               CommonButton,
               CompanySelectInput,
               LanguageSelectInput,
               AppendixSelectInput,
            SessionTimer,
            SessionSelector
        }
    })
    export default class Header extends Vue {
        private logoFailureCount = 0;
        private userIdVisible: boolean = false;
        private helpVisible: boolean = false;
        private helpDeskLoading: boolean = false;
        private popupWindow: any;

        private myInfoVisible: boolean = false;
        private changePasswordLoading: boolean = false;
        private changePasswordTried: boolean = false;

        get userNameId() {
            return `${this.$store.getters.userName}/${this.$store.getters.userId}`;
        }

        get version() {
            return `Version: 1.1`;
        }

        get lastReleaseDate() {
          return `Last Release Date: 20240929`;
        }

        get getLogoUrl() {
            return `${appProp.origin}/1.0/sponsors/${this.sponsorKey}/company-logo`;
        }

        get isAlibabaProfile(): boolean {
            return location.hostname.indexOf('cn') >= 0;
        }

        get isAdmin() {
          return this.$route.meta.isAdmin;
        }

        get sponsorKey() {
          return this.isAdmin ? '1' : this.$route.params.sponsorKey;
        }

        public onClickLogo() {
            this.$router.push({
                name: this.isAdmin ? 'SystemAdmin' : 'Home',
                params: {
                    ...ApiUtils.extractRequiredParams(this.$route.params),
                }
            });
        }

        public onClickManual() {
          const origin = appProp.origin;
          const accessToken = AppSession.getAccessToken();
          const newTab = window.open(``, '_blank');
          newTab!.location.href = `${origin}/open-api/v1.1/manuals?accessToken=${accessToken}`;
        }

        public onClickHelpCenter() {
            this.helpDeskLoading = true;
            UserApi.getHelpdeskTokens()
                   .then((res: HelpdeskTokenRetrieveResponse) => {
                       if (res.status === 'success') {
                           window.open(res.result.redirectURL, '_blank');
                       } else {
                           this.openPopupWindow(res);
                       }
                   })
                   .catch((err) => console.error(err))
                   .finally(() => this.helpDeskLoading = false);
        }

        public onClickPrivacyPolicy() {
            let lang = this.$route.params.language;
            if (lang === 'zh') {
                lang = 'cn';
            } else if (lang === 'ja') {
                lang = 'jp';
            }

            const url = `https://www.crscube.io/privacyPolicy?locale=${lang}`;
            window.open(url, `_blank`);
        }

        private openPopupWindow(res: HelpdeskTokenRetrieveResponse) {
            if (this.popupWindow && !this.popupWindow.closed) {
                if (this.popupWindow.focus) {
                    this.popupWindow.focus();
                }
                return;
            }
            this.createPopupWindow(res);
        }

        private createPopupWindow(res: HelpdeskTokenRetrieveResponse) {
            const width = 580;
            const height = 650;

            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const screenWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth
                ? document.documentElement.clientWidth : screen.width;

            const systemZoom = screenWidth / window.screen.availWidth;
            const xPosition = (screenWidth - width) / 2 / systemZoom + dualScreenLeft;
            const yPosition = 20;

            this.popupWindow = window.open(res.result.redirectURL, '_blank',
                `width=${width}, height=${height}, left=${xPosition}, top=${yPosition}`
                + ',location=no,status=no,menubar=no,scrollbars=no,resizable=no');

            if (this.popupWindow && this.popupWindow.focus) {
                this.popupWindow.focus();
            }

            window.onmessage = (e: any) => {
                if (e.data === 'POLICY_AGREED') {
                    this.onClickHelpCenter();
                } else {
                    if (this.popupWindow) {
                        this.popupWindow.close();
                    }
                    this.popupWindow = null;
                }
            };
        }

        public onLogoUndefined(event: any) {
            if (this.logoFailureCount > 3) {
                return;
            }
            this.logoFailureCount++;
            event.target.src = require('@/assets/image/logo_safety.svg');
        }

        public onClickChangepassword() {
            this.changePasswordLoading = true;
            this.changePasswordTried = true;
            UserApi.sendPasswordResetEmail(this.$store.getters.userId)
                   .then((res: SendPasswordResetEmailResponse) => {
                       MessageUtils.displaySuccessMessage(res.data.message, {
                           duration: 0
                       });
                   })
                   .finally(() => this.changePasswordLoading = false);
        }

        public onLogout() {
            ApiUtils.logout(this.$route.params.sponsorKey,
                'Logout - User', this.$store, null, this.$route);
        }
    }
